import { Reveal } from "@/components/Reveal";

const BRANDS = [
  { src: "/brands/sungrace-mafatlal.png", name: "Sungrace Mafatlal — Exclusive Suiting Collection" },
  { src: "/brands/mukesh-trendz.png", name: "Mukesh Trendz LLP — A Trusted Brand in Sarees", blend: false },
  { src: "/brands/goodwill.png", name: "Goodwill — Suitings & Shirtings", blend: false },
  { src: "/brands/sundar.png", name: "Sundar — Original Guaranteed" },
  { src: "/brands/pranjul.png", name: "Pranjul Fashion Pvt. Ltd." },
  { src: "/brands/bd.png", name: "BD — Since 1975" },
  { src: "/brands/shree-ganesh.png", name: "Shree Ganesh Print-Fab Pvt. Ltd." },
  { src: "/brands/ridhi-sidhi.png", name: "Ridhi Sidhi" },
  { src: "/brands/arrmeelon.png", name: "Arrmeelon Mumbai — Uniform Shirtings" },
  { src: "/brands/rtc-mills.png", name: "RTC Mills LLP — Legacy of Trust & Quality" },
  { src: "/brands/mocky-tocky.png", name: "Mocky Tocky — School & Work Wear Uniforms" },
];

const Brands = () => (
  <section data-testid="brands-section" className="overflow-hidden border-y border-ink/10 bg-sand py-14 sm:py-16">
    <Reveal>
      <p className="flex items-center justify-center gap-4 px-6 font-accent text-[11px] font-semibold tracking-[0.35em] text-crimson">
        <span className="h-px w-12 bg-crimson" /> BRANDS IN COLLABORATION <span className="h-px w-12 bg-crimson" />
      </p>
    </Reveal>
    <div className="mt-10 overflow-hidden">
      <div className="marquee-track flex w-max items-center gap-14 pr-14 sm:gap-20 sm:pr-20">
        {[...BRANDS, ...BRANDS].map((b, i) => (
          <img
            key={`${b.src}-${i}`}
            data-testid={i < BRANDS.length ? `brand-logo-${b.src.split("/").pop().replace(".png", "")}` : undefined}
            src={b.src}
            alt={b.name}
            title={b.name}
            loading="lazy"
            className={`h-14 w-auto object-contain sm:h-16 ${b.blend === false ? "" : "mix-blend-multiply"}`}
          />
        ))}
      </div>
    </div>
    <Reveal delay={0.1}>
      <p className="mt-10 px-6 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-clay/80">
        Authorised stock for trusted mills & labels · more in store
      </p>
    </Reveal>
  </section>
);

export default Brands;
